
const state = {
  default: false,
  expires_at: '',
  hidden: false,
  id: null,
  is_master: false,
  master_price_list_id: undefined,
  master_price_list_version: undefined,
  next_price_list_id: undefined,
  provider_id: undefined,
  public_token: undefined,
  service_id: undefined,
  soft_match_codes: false,
  title: '',
}

export const requiredFields = [
  { key: 'provider_id' },
  { key: 'service_id' },
  { key: 'title' },
]

export default state
